export const tabBar = [
  {
    to: '/home',
    icon: require('../assets/images/desktop/home.png'),
    iconed: require('../assets/images/desktop/homed.png'),
    title: '首页'
  },
  // {
  //   to: "/kehu",
  //   icon: "kehu1",
  //   title: "客户"
  // },
  {
    to: '/tongji',
    icon: require('../assets/images/desktop/tongji.png'),
    iconed: require('../assets/images/desktop/tongjied.png'),
    title: '统计'
  },
  {
    to: '/daiban',
    icon: require('../assets/images/desktop/daiban.png'),
    iconed: require('../assets/images/desktop/daibaned.png'),
    title: '待办'
  },
  {
    to: '/shezhi',
    icon: require('../assets/images/desktop/mine.png'),
    iconed: require('../assets/images/desktop/mined.png'),
    title: '我的'
  }
]
